import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { SolutionIntro } from '../components/SolutionIntro';
import { Volumes } from '../components/Volumes';
import { InsidePreview } from '../components/InsidePreview';
import { Bonuses } from '../components/Bonuses';
import { Benefits } from '../components/Benefits';
import { SpecialOffer } from '../components/SpecialOffer';
import { Guarantee } from '../components/Guarantee';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { LastChance } from '../components/LastChance';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="min-h-screen bg-navy-950 text-white font-inter selection:bg-gold-500/30 selection:text-gold-200" data-id="element-257">
      <Hero data-id="element-258" />
      <PainPoints data-id="element-259" />
      <SolutionIntro data-id="element-260" />
      <Volumes data-id="element-261" />
      <InsidePreview data-id="element-262" />
      <Bonuses data-id="element-263" />
      <Benefits data-id="element-264" />
      <SpecialOffer data-id="element-265" />
      <Guarantee data-id="element-266" />
      <Testimonials data-id="element-267" />
      <FAQ data-id="element-268" />
      <LastChance data-id="element-269" />
      <Footer data-id="element-270" />
    </main>;
}